import firebase from 'firebase/app';
import _ from 'lodash';

export default {
  namespaced: true,
  state: {
    allUser:{},
    status:false,
    allTeam:{},
    teamHeight:'',
    organization:{}
  },
  mutations: {
    setAllUser(state:any, result:any) {
        state.allUser = result
      },
    setAllTeam(state:any, result:any) {
        state.allTeam = result
      },
      setteamHeight(state:any, result:any) {
        state.teamHeight = result
      },
      setOrganization(state:any, result:any) {
        state.organization = result
      }
  },
  actions: {
    async getuser({commit,state,rootState}:any,update:any){
      return new Promise((resolve, reject) => {
        if(Object.keys(state.allUser).length === 0||update==true){
          var axios = require('axios');
          var data = JSON.stringify({
            "c": rootState.authen.user.company,
            "t": "users"
          });
          const config = {
            method: 'post',
            url: 'https://api-node.happily.ai/cache/get',
            headers: {
              'Content-Type': 'application/json'
            },
            data : data
          };
         axios(config)
          .then(response => {
              const data = response.data
              commit("newmember/setUpdateMember", false,{root:true});
              commit('setAllUser',data)
              resolve(data);
          })
          .catch(err => {
              reject({ errorMessage: err.message });
          })
        }
 
    });




    },
    async removeUser({commit,state,rootState,dispatch}:any,update:any){
        return new Promise((resolve, reject) => {
         
            var axios = require('axios');
            var data = JSON.stringify({
              "c": rootState.authen.user.company,
              "t": "users"
            });
            const config = {
              method: 'post',
              url: 'https://api-node.happily.ai/cache/removeTable',
              headers: {
                'Content-Type': 'application/json'
              },
              data : data
            };
           axios(config)
            .then(response => {
              //console.log("data")
                const data = response.data
                resolve(data);
                dispatch("getuser",true)
            })
            .catch(err => {
              console.log("err",err)
                reject({ errorMessage: err.message });
            })
          
   
      });
  
  
  
  
    },
    async getteam({commit,state,rootState}:any,update:any){
      if(Object.keys(state.allTeam).length === 0||update==true){

        var axios = require('axios');
        var data = JSON.stringify({
          "c": rootState.authen.user.company,
          "t": "team"
        });
        
        const config = {
          method: 'post',
          url: 'https://api-node.happily.ai/cache/get',
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };
        axios(config)
        .then(function (response) {
          const data = response.data
          commit('setAllTeam',data)
        })
        .catch(function (error) {
          console.log(error);
        });

      }
    },
    async getteamHeight({commit,state,rootState}:any){
            let topmostArr: Array<any> = [];
            let teamHeight:any
            let team = (await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            for(const i in team){
                team[i].key=i
                if(!team[i].parent){
                  topmostArr.push(i)
                }
            }
            teamHeight = topmostArr[0]
            if(topmostArr.length > 1){
              teamHeight = _.find(topmostArr, (value) => {
              const chk_topmost = _.find(team, { parent: value });
              return !!chk_topmost;
              });
            }
            console.log("teamHeight",teamHeight)
            commit('setTeamHeight',teamHeight)
    },
    async getOrganization({commit,state,rootState}:any){
      const result={}
      await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
      .then((querySnapshot)=> {
              querySnapshot.forEach((doc)=> {
                const team_id=doc.data().team_id
                if(!result[team_id]){
                  result[team_id]=doc.data().parent
                }
              });
              //console.log('result',result)
              commit('setOrganization', result)
      });
    }
  
  },
  getters: {
    allUser : (state:any) => {
      return state.allUser
    },
    allTeam : (state:any) => {
      return state.allTeam
    },
    teamHeight : (state:any) => {
      return state.teamHeight
    },
    organization : (state:any) => {
      return state.organization
    }
  }
}